import { FieldBase } from '@/domain/mitarbeiter/shared/components/form/fieldComponents/FieldBase';
import { useAnlageassistentFormContext } from '@/domain/mitarbeiter/features/anlageassistent/context/AnlageassistentFormContext';
import { useErfahrungslevelOptions } from '@/domain/mitarbeiter/features/anlageassistent/hooks/useErfahrungslevelOptions';
import { Erfahrungslevel } from '@/domain/mitarbeiter/features/anlageassistent/utils/constants/erfahrungslevel';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@e2n/ui/v2';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

export function ErfahrungslevelSelect() {
  const { t } = useTranslation();
  const form = useAnlageassistentFormContext();
  const options = useErfahrungslevelOptions();

  return (
    <form.AppField name="person.arbeitsbereiche.erfahrungslevel">
      {(field) => {
        const selectedErfahrungslevel = options.find(
          (ab) => ab.key === field.state.value,
        );

        return (
          <FieldBase
            label={t(
              'domain.mitarbeiter.create.steps.person.arbeitsbereiche.form.erfahrungslevel.label',
            )}>
            <Select
              value={field.state.value ?? ''}
              onValueChange={(val) =>
                field.handleChange(val as Erfahrungslevel)
              }>
              <SelectTrigger
                showLeftIcon
                leftIcon={
                  selectedErfahrungslevel ? (
                    <FontAwesomeIcon icon={selectedErfahrungslevel.icon} />
                  ) : null
                }>
                <SelectValue placeholder={t('combobox.placeholder')} />
              </SelectTrigger>
              <SelectContent
                title={t(
                  `domain.mitarbeiter.create.steps.person.arbeitsbereiche.form.erfahrungslevel.label`,
                )}>
                {options.map((o) => (
                  <SelectItem
                    key={o.key}
                    value={o.key}
                    showLeftIcon
                    leftIcon={<FontAwesomeIcon icon={o.icon} />}>
                    {o.name}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </FieldBase>
        );
      }}
    </form.AppField>
  );
}
